import cSkeleton from '#themes/default/default/components/skeleton/skeleton.js';
import cTooltip from '#themes/default/default/components/tooltip/tooltip.js';

import template from './ibanInput.html' with { type: 'html' };

export default {
	name: 'CCardInput',
	components: {
		cSkeleton,
		cTooltip
	},
	props: {
		form: {
			type: Object,
			default: () => {}
		},
		ibanHasError: {
			type: Boolean,
			default: false
		},
		isEmpty: {
			type: Boolean,
			default: true
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		size: {
			type: String,
			default: 'medium'
		},
		theme: {
			type: Object,
			default: () => {}
		},
		url: {
			type: Object,
			default: () => null
		}
	},
	data() {
		return {
			note: '',
			hasFocus: false
		};
	},
	computed: {
		isTouched() {
			return Boolean(this.form.directDebit?.touched);
		},
		isSubmitted() {
			return Boolean(this.form.directDebit?.submitted);
		},
		isCompleted() {
			return Boolean(this.form.directDebit?.completed);
		},
		isSubmittedUntouched() {
			return this.isSubmitted && !this.isTouched;
		},
		directDebitErrors() {
			return this.ibanHasError || this.isSubmittedUntouched;
		},
		inputsLoaded() {
			return Boolean(this.selectedPayment.iban);
		}
	},
	methods: {
		onBlur() {
			this.hasFocus = false;
			this.note = '';
		},
		onFocus() {
			this.hasFocus = true;
			this.note = this.t('directDebit_ibanNote');
		}
	},
	template
};
